import mutate from 'js-core/js/apollo/mutations/mutate';
import invalidateQuery from 'js-core/js/apollo/mutations/invalidateQuery';

import CreateShipMutation from 'gql/mutations/Ship/CreateShip.gql';
import UpdateShipMutation from 'gql/mutations/Ship/UpdateShip.gql';
import DeleteShipMutation from 'gql/mutations/Ship/DeleteShip.gql';

export default class{

    static create(input) {

        return mutate(CreateShipMutation, { input }, store => {

            invalidateQuery(store, 'allShips');
        });
    }

    static update(input) {

        return mutate(UpdateShipMutation, { input }, store => {

            invalidateQuery(store, 'allShips');
        });
    }

    static delete(id) {

        return mutate(DeleteShipMutation, { id }, store => {

            invalidateQuery(store, 'allShips');
        });
    }
}
